import axios from 'axios'
import { withResilience } from './resilience'

/*
 * Central resilient fetch/axios wrappers
 *
 * Drop-in replacements for `fetch` and `axios` that add the shared
 * retry + circuit breaker behaviour from ./resilience. Use these instead
 * of calling `fetch`/`axios` directly from components, hooks or effects.
 */

export const resilientFetch = (url, options) =>
  withResilience(url, () => fetch(url, options))

export const resilientAxios = {
  get: (url, config) => withResilience(url, () => axios.get(url, config)),
  post: (url, data, config) => withResilience(url, () => axios.post(url, data, config)),
  put: (url, data, config) => withResilience(url, () => axios.put(url, data, config)),
  delete: (url, config) => withResilience(url, () => axios.delete(url, config)),
  request: (config) => withResilience(config.url, () => axios(config)),
}
